import React from 'react';

export function CustomFooter() {
    return (
        <footer className="app-footer">
            <div className="footer-flex">
                <div className="footer-copy">
                    <strong>
                        <i className="fas fa-copyright"></i> 2022-2025
                    </strong>
                    <a
                        href="https://4soluciones.net"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-link"
                    >
                        4soluciones.net
                    </a>
                </div>
                <div className="footer-badge">
                    <i className="fas fa-code-branch"></i>
                    <span>Version 3.2.0</span>
                </div>
            </div>
        </footer>
    );
}

